function t(l) {
  return l.filter((r) => r != null);
}
export {
  t as filterNullish
};
//# sourceMappingURL=filter-nullish.es.js.map
